import './Departamento.css';
import Footer from '../../components/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {Component} from 'react';
import GoBackButton from '../../components/GoBackButton';

class Pedagogia extends Component {
    componentDidMount(){
        window.scrollTo(0, 0);
    }
    render(){
        return (
            <div className='departamento'>
                <div className="PedagogiaHeader">
                    <GoBackButton></GoBackButton>
                </div>
                <div className="DepartamentoMain">
               <div id="introduçao">
                    <p>
                        Uma Associação de Estudantes tem de pôr em primeiro lugar, por princípio, a defesa dos
                        superiores interesses dos estudantes. Acreditamos que todos, independentemente da sua
                        raça, nacionalidade, género, orientação sexual ou situação económica, devem ter acesso a
                        um ensino de elevada qualidade e a vantajosas oportunidades de emprego quando
                        terminarem o seu percurso académico. O departamento de Pedagogia e Emprego da
                        AEFEUP tem, assim, o propósito de garantir uma integral formação de todos os alunos, assim
                        como facilitar o contacto com empresas e com o mundo do trabalho. Será também este o
                        departamento que fará a ponte entre a AEFEUP e as Comissões de Acompanhamento dos
                        vários cursos da FEUP , e, por isso, irá reunir frequentemente com as mesmas.   
                    </p>
                    <p>
                        Hoje em dia, os estudantes são confrontados com uma série de entraves, como a
                        desintegração dos mestrados, a subida da propina de mestrado, a crescente inflação e
                        estagnação salarial e as regras para candidatura a programas de mobilidade. É da
                        responsabilidade deste departamento, então, manter a proximidade com os correntes
                        problemas dos estudantes e procurar soluções inovadoras, defendendo de forma
                        adequada os estudantes junto das entidades competentes.
                    </p>
        
               </div>
        
               <div className="container">
                   <div className="row">
                            <div className="col-sm">
                              <div>
                              <h2>Feira de Emprego</h2>
                    
                                <p>A nosso ver, é de extrema relevância a realização de feiras de emprego e inovação como o
                                    FEUP Engineering Days, uma vez que promovem um contacto direto entre as empresas e os
                                    estudantes. É importante compreender as feiras do ponto de vista do estudante e futuro
                                    empregado e promover a realização de workshops que ajudem a preparar o mesmo para
                                    uma entrevista de emprego. Serão realizadas atividades como:
                                
                                <ul>
                                    <li>Sessões de networking;</li>
                                    <li>Workshops de interesse para a preparação da entrada no mercado de trabalho, tais como:
                                        <ul>
                                            <li>Escrita de um Curriculum Vitae ou uma carta de motivação;</li>
                                            <li>Como reagir numa entrevista de emprego;</li>
                                            <li>Pitch Bootcamps.</li>
                                        </ul>
                                    </li>
        
                                </ul></p>
                                </div>
                            </div>
        
                            <div className="col-sm">
                                <div>
                                <h2>Feira de Investigação</h2>
                                <p>
                                    Também de grande relevância é realizarem-se, a nosso ver, feiras que incluam
                                    apresentações de projetos de investigação a serem feitos na faculdade, envolvendo, por
                                    exemplo, centros de investigação. Julgamos que esta feira será não só útil para alunos que
                                    estejam ainda a decidir que temas escolher para a sua tese, mas também poderá
                                    constituir uma importante ferramenta para aqueles que estejam a pensar abrir uma
                                    empresa.
                                </p>
                                </div>
                            </div>
                    </div>
                </div>
        
                <div className="container">
                   <div className="row">
                            <div className="col-sm">
                              <div>
                              <h2>Bolsas de Emprego, Estágios de Verão e Oportunidades de Emprego</h2>
                    
                                <p>Divulgação, em conjunto com a unidade TALENT da FEUP, da Bolsa de Emprego e de Estágios
                                    de Verão, bem como de oportunidades de emprego direcionadas aos estudantes.
                                    Pretende-se promover a renovação da plataforma e a melhoria ao nível da interface e
                                    usabilidade de modo a ser mais apelativo e de mais fácil acesso, melhorar a capacidade
                                    de filtragem de modo a apresentar as propostas mais importantes e direcionadas a cada
                                    curso e a cada indivíduo é algo a ter em atenção. Pretendemos também promover a
                                    realização de atividades de Job Shadowing, isto é, situações onde o estudante aprende
                                    junto de quem trabalha. Pretendemos promover visitas de estudo e saídas de campo
                                    envolvendo todas as áreas de engenharia.
                                </p>
                                </div>
                            </div>
        
                            <div className="col-sm">
                                <div>
                                <h2>Mestrados, Doutoramentos, Pós Graduações e Bolsas:</h2>
                                <p>Pretendemos realizar sessões de esclarecimento com o maior número possível de estudantes sobre:  
                                <ul>
                                    <li>Como se estruturam os mestrados, doutoramentos e pós graduações;</li>
                                    <li>Quais as bolsas disponíveis e como concorrer a elas.</li>
                                </ul></p>                  
                                </div>
                            </div>
                    </div>
                </div>
                <div className="container">
                   <div className="row">
                            <div className="col-sm">
                              <div>
                              <h2>Jornal da Associação de Estudantes, com Agenda Cultural</h2>
                    
                                <p>Os estudantes devem ter conhecimento do que se passa na sua Associação de Estudantes
                                    e um jornal seria um espaço ideal para isso. Para além de notícias, relatando a ação da
                                    associação, acontecimentos na Faculdade e outros assuntos do interesse dos estudantes,
                                    este jornal daria a oportunidade aos estudantes para escreverem artigos de opinião. Por
                                    fim, contaria ainda com uma agenda cultural, publicitando eventos culturais na cidade.</p>
                                </div>
                            </div>
        
                            <div className="col-sm">
                                <div>
                                <h2>Exposições e Teatro no Espaço da AE</h2>
                                <p>
                                    Dar oportunidade aos estudantes de exporem os seus trabalhos dos concursos e dos
                                    workshops, revitalizando o espaço da AEFEUP. Promoveremos a realização de peças de
                                    teatro, sejam com estudantes da Faculdade ou com companhias, dando a conhecer
                                    melhor a importância desta arte performativa. Criaremos exposições de peças artísticas
                                    realizadas pelos estudantes da FEUP, bem como em parceria com outras faculdades
                                    (FBAUP, FLUP ou FAUP, por exemplo), para expor obras dos seus estudantes, que se
                                    enquadrem na Faculdade de Engenharia.
                                </p>
        
                                <br/>
                                </div>
                            </div>
                    </div>
                </div>
                <div className ='paragrafo'>
                    <h2>Formação Contínua:</h2>
                    <p>Disponibilizaremos cursos variados de línguas e a preços acessíveis, uma vez que são uma
                        ferramenta muito importante e valorizada pelo mercado de trabalho. Organizaremos
                        formações creditadas e certificadas por entidades externas, ou em parceria com os núcleos
                        existentes na FEUP, em ferramentas técnicas ou informáticas, consoante o que for mais
                        vantajoso para a formação dos estudantes, como por exemplo em:
                    
                    <ul>
                        <li>Revit;</li>
                        <li>SolidWorks;</li>
                        <li>Java;</li>
                        <li>Python;</li>
                        <li>Excel.</li>
                    </ul></p>
                    <p>Procuraremos sempre a escolha de formações de qualidade, e que abranjam a
                        generalidade dos cursos, a um preço acessível a todos, podendo também ser
                        disponibilizado um subsídio para estudantes bolseiros ou, eventualmente, para a
                        globalidade dos estudantes. Pretende-se, também, promover a realização de sorteios de
                        cursos para promover a participação nos mesmos.
                    </p>
                    <p>Pretendemos, inclusivamente, promover a organização de cursos e palestras sobre:
                    <ul>
                        <li>Comunicação em Ciência;</li>
                        <li>Estratégias para Falar em Público;</li>
                        <li>Gestão de Prioridades;</li>
                        <li>Ciência Aberta e aquilo que pode ser alcançado com esse método de estruturação do conhecimento.</li>
                    </ul></p>
                </div>
                <div className ='paragrafo' id = 'last'>
                    <h2>Comissões de Acompanhamento e Conselho Pedagógico</h2>
                    <p>A desintegração dos mestrados integrados, tal como a consequente subida de propina de
                        mestrado, revelou-se caótica e introduziu novos problemas na vida de muitos estudantes.
                        Professores e alunos viram-se obrigados a adaptar-se a novas condições de ensino, sem
                        melhoria da qualidade do mesmo. Pretende-se criar um grupo de trabalho, favorecendo a
                        consolidação e articulação das atividades das Comissões de Acompanhamento e de modo
                        a aumentar a divulgação destas, que são distintas de curso para curso. Queremos também
                        possibilitar a coordenação entre as comissões referentes à Licenciatura e ao Mestrado. Para
                        além disso, pretende-se apoiar as Comissões de Acompanhamento em quesito de
                        resolução de problemas, reforçando a comunicação junto de entidades competentes
                        quando seja necessário. A Lista E propõe, então, realizar frequentemente reuniões com as
                        Comissões de Acompanhamento e com o Conselho Pedagógico para saber quais as
                        dificuldades que os estudantes estão a enfrentar.
                    </p>
                </div>
                
            </div>
            <button id='scrollToTopBtn' className='scrollToTopBtn'>
                <FontAwesomeIcon icon={faArrowUp} size="lg" />
            </button>
        
            <Footer></Footer>
                
            </div>
          );
    }

}

export default Pedagogia;
